import { lazyOpenBizChatSidePaneWithAgent } from "owa-bizchat-shared";
import type { AgentType } from "owa-bizchat-types";
import type { ChatInputRawEntityData } from "@1js/scc-types";
import type { QueryAnnotation } from "@1js/sydney-types";
import type { IContextualChat } from "owa-bizchat-types/lib/types";
import type { MailboxInfo } from "owa-client-types";

export type OpenAgentChatPaneOptions = {
    promptText: string;
    agentType?: AgentType;
    targetWindow: Window;
    shouldExecuteQuery?: boolean;
    rawEntityData?: ChatInputRawEntityData[];
    queryAnnotations?: QueryAnnotation[];
    formCode?: string;
    contextualChat?: IContextualChat;
    mailboxInfo: MailboxInfo;
};

/**
 * Opens the Copilot chat side pane with an agent @mentioned and the specified prompt.
 * Mirrors openChatPane but routes through openBizChatSidePaneWithAgent to preserve
 * the prompt while targeting the agent.
 */
export const openAgentChatPane = ({ promptText, agentType, targetWindow, shouldExecuteQuery, rawEntityData, queryAnnotations, formCode, contextualChat, mailboxInfo, }: OpenAgentChatPaneOptions): void => {
    lazyOpenBizChatSidePaneWithAgent.importAndExecute({
        source: "CopilotDabRibbonSUA",
        promptText,
        agentType,
        shouldExecuteQuery,
        rawEntityData,
        queryAnnotations,
        formCode,
        isNewChat: true,
        targetWindow,
        contextualChat,
        mailboxInfo,
    });
};
